import { render, staticRenderFns } from "./ServiceStaffPostModal.vue?vue&type=template&id=3497f373&"
import script from "./ServiceStaffPostModal.vue?vue&type=script&lang=ts&"
export * from "./ServiceStaffPostModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports